import getTheCurrentYear from 'shared/lib/functions/getTheCurrentYear';

export const CURRENT_YEAR = getTheCurrentYear();
